import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import Footer from './Footer';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            minHeight: '100vh',
            background: '#000000',
            color: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Decorative Glows */}
            <div style={{
                position: 'absolute', top: '10%', left: '20%',
                width: '400px', height: '400px',
                background: 'radial-gradient(circle, rgba(34,197,94,0.15) 0%, transparent 70%)',
                filter: 'blur(60px)', pointerEvents: 'none'
            }} />
            <div style={{
                position: 'absolute', bottom: '10%', right: '20%',
                width: '500px', height: '500px',
                background: 'radial-gradient(circle, rgba(34,197,94,0.1) 0%, transparent 70%)',
                filter: 'blur(80px)', pointerEvents: 'none'
            }} />

            <div style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                zIndex: 1
            }}>
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    style={{
                        maxWidth: '500px',
                        width: '100%',
                        textAlign: 'center',
                        padding: '48px 32px',
                        borderRadius: '32px',
                        background: 'rgba(255, 255, 255, 0.03)',
                        backdropFilter: 'blur(20px)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
                    }}
                >
                    <motion.div
                        animate={{
                            y: [0, -15, 0],
                            rotate: [0, 5, -5, 0]
                        }}
                        transition={{
                            duration: 5,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                        style={{
                            fontSize: '120px',
                            fontWeight: 900,
                            lineHeight: 1,
                            marginBottom: '24px',
                            background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            display: 'inline-block'
                        }}
                    >
                        404
                    </motion.div>

                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: 800,
                        marginBottom: '16px',
                        letterSpacing: '-0.02em'
                    }}>
                        Page Not Found
                    </h1>

                    <p style={{
                        fontSize: '16px',
                        color: 'rgba(255,255,255,0.6)',
                        marginBottom: '40px',
                        lineHeight: 1.6
                    }}>
                        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                    </p>

                    <div style={{
                        display: 'flex',
                        gap: '16px',
                        justifyContent: 'center'
                    }}>
                        <motion.button
                            whileHover={{ scale: 1.05, backgroundColor: '#16a34a' }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => navigate('/')}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '14px 28px',
                                borderRadius: '14px',
                                background: '#22c55e',
                                color: '#ffffff',
                                border: 'none',
                                fontSize: '15px',
                                fontWeight: 700,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                boxShadow: '0 10px 15px -3px rgba(34, 197, 94, 0.3)'
                            }}
                        >
                            <FiHome size={18} />
                            Home
                        </motion.button>

                        <motion.button
                            whileHover={{ scale: 1.05, background: 'rgba(255,255,255,0.08)' }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => navigate(-1)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '14px 28px',
                                borderRadius: '14px',
                                background: 'rgba(255,255,255,0.05)',
                                color: '#ffffff',
                                border: '1px solid rgba(255,255,255,0.1)',
                                fontSize: '15px',
                                fontWeight: 700,
                                cursor: 'pointer',
                                transition: 'background 0.2s'
                            }}
                        >
                            <FiArrowLeft size={18} />
                            Go Back
                        </motion.button>
                    </div>
                </motion.div>
            </div>

            <Footer />
        </div>
    );
};

export default NotFound;
